export const modalReservationDirect = {
  header: {
    title: "Réservations directes en ligne",
    subtitle: "Définissez ce que le client voit et comment les règles s'appliquent.",
  },
  tabs: {
    reservations: "Statut des réservations",
    ratePlans: "Tarifs",
    promotions: "Promotions",
    addons: "Frais supplémentaires",
    payments: "Prix et paiements",
    share: "Partager",
  },
  common: {
    close: "Fermer",
    updating: "Mise à jour…",
    hotel: "Hôtel",
    apartment: "Appartement",
    visible: "Visible",
    default: "Par défaut",
    dragToReorder: "Glissez pour réorganiser",
    saving: "Enregistrement…",
    preview: "Aperçu",
  },
  toast: {
    successTitle: "Succès",
  },
  save: {
    ratePlans: "Enregistrer les tarifs",
    promotions: "Enregistrer les promotions",
    addons: "Enregistrer les frais",
    default: "Enregistrer",
  },
  reservations: {
    cardTitle: "Statut des réservations directes",
    cardDesc: "Activez ou désactivez la disponibilité des réservations directes (globalement et par unité).",
    activateTitle: "Activer les réservations directes",
    activateHelp: "Si cette option est désactivée, vous ne pouvez pas activer d'unités individuelles.",
    colName: "Hébergement / Unité",
    colCapacity: "Capacité",
    colAvailable: "Disponible",
    emptyUnits: "Aucune unité configurée pour cette propriété.",
  },
  ratePlans: {
    title: "Tarifs affichés dans la réservation directe",
    hotelDesc: "Définissez les tarifs affichés pour chaque type de chambre",
    apartmentDesc: "Choisissez les plans tarifaires que le client voit, celui par défaut et l'ordre",
    loading: "Chargement des tarifs…",
    emptyApartment: "Aucun tarif configuré pour cette propriété.",
    emptyHotel: "Aucun type de chambre configuré pour cet hôtel.",
    emptyRoom: "Aucun tarif configuré pour cette chambre.",
    colTarifa: "Tarif",
    colVisibleName: "Nom affiché",
    visibleNameTooltip: "Nom facultatif à afficher au client",
    namePlaceholderApartment: "p. ex. Non remboursable / Flexible",
    namePlaceholderHotel: "p. ex. Petit-déjeuner inclus",
    derivedBadge: "Dérivé",
    rulesApartment: "Règles : au moins 1 visible et 1 par défaut (qui doit être visible).",
    rulesHotel: "Chaque chambre doit avoir au moins 1 tarif visible et 1 tarif par défaut.",
  },
  rooms: {
    ratesCount: "{count} tarif | {count} tarifs",
    meta: "Capacité : {capacity} • Adultes : {adults} • Enfants : {children}",
  },
  promotions: {
    title: "Promotions dans la réservation directe",
    desc: "Contrôlez lesquelles sont affichées, si elles s'appliquent automatiquement et leur ordre.",
    loading: "Chargement des promotions…",
    empty: "Aucune promotion configurée pour cette propriété.",
    colPromo: "Promotion",
    colBadge: "Badge",
    badgeTooltip: "Texte court (p. ex. -10%, Offre, Réservation anticipée).",
    colAuto: "Application automatique",
    colStackable: "Cumulable",
    badgePlaceholder: "p. ex. -10% / Offre",
    tip: "Conseil : si vous ne voulez pas qu'une promotion affecte le prix final, désactivez “Application automatique” et gardez-la visible.",
    fromDate: "À partir du {date}",
    untilDate: "Jusqu'au {date}",
  },
  addons: {
    loading: "Chargement des paramètres…",
    subtabOccupancy: "Réduction selon l'occupation",
    subtabExtraGuest: "Frais par client supplémentaire",
    baseOccupancyTitle: "Occupation de base",
    baseOccupancyDesc: "Le prix habituel correspond à cette occupation. Pour un nombre de clients inférieur, vous appliquez une réduction.",
    guestsLabel: "clients",
    headOccupancy: "Occupation",
    headRule: "Règle",
    headValue: "Valeur",
    headActive: "Actif",
    guestWord: "client | clients",
    usualPrice: "Prix habituel",
    modePercent: "Réduction %",
    modeFixed: "Réduction fixe (par nuit)",
    occupancyExample: "Exemple : base de 4 clients et réductions pour 3, 2 et 1.",
    configTitle: "Paramètres",
    configDesc: "Appliquez un supplément pour chaque client supplémentaire au-delà de l'occupation incluse.",
    activate: "Activer",
    includedTitle: "Occupation incluse",
    includedDesc: "Reprise automatiquement de la capacité de l'hébergement.",
    maxExtraLabel: "Nombre maximum de clients supplémentaires autorisés",
    maxHelpHtml: "Combien de clients peuvent être ajoutés <b>en plus de l'occupation incluse</b>.<br />Si vous définissez <b>0</b>, aucun client supplémentaire n'est autorisé.<br />Si vous laissez le champ vide, il n'y a pas de limite.",
    chargeTypeLabel: "Type de frais",
    chargeTypeFixed: "Montant fixe",
    chargeTypePercentage: "Pourcentage",
    chargeTypeHelp: "Fixe : {currency} par client supplémentaire. Pourcentage : % du prix de base.",
    priceLabel: "Prix par client supplémentaire",
    appliesHelp: "Appliqué par client supplémentaire.",
    appliesBlockedNote: "(Aucun client supplémentaire autorisé lorsque le maximum est 0)",
    applicationLabel: "Application",
    applicationNote: "Pour l'instant, ce frais s'applique par nuit.",
    previewFixed: "Chaque client supplémentaire ajoute <b>{amount}</b> par nuit.",
    previewPercent: "Chaque client supplémentaire ajoute <b>{percent}%</b> du prix de base par nuit.",
    singleValueNote: "Il s'agit d'une <b>valeur unique</b> (p. ex. +10 {currency} ou +15% par client supplémentaire).",
  },
  payments: {
    title: "Prix et paiements",
    desc: "Type de frais et réductions pour les réservations directes.",
    paymentTypeTitle: "Type de paiement",
    onArrivalLabel: "Payer à l'arrivée",
    onArrivalDesc: "Le client réserve et paie directement à l'arrivée.",
    onlineLabel: "Paiement en ligne",
    onlineDesc: "Le client paie en ligne au moment de finaliser la réservation.",
    discountsTitle: "Réductions",
    enableDiscount: "Activer la réduction sur les réservations directes",
    discountTypeTitle: "Type de réduction",
    typePercentage: "Pourcentage",
    typePercentageDesc: "Réduction proportionnelle au total.",
    typeFixed: "Fixe",
    typeFixedDesc: "Montant fixe à déduire.",
    valueTitle: "Valeur",
    placeholderPercentage: "p. ex. 10",
    placeholderFixed: "p. ex. 15.00",
    helpPercentage: "Maximum 100%. Appliqué au total.",
    helpFixed: "Un montant fixe est déduit en {currency}.",
    previewPercentage: "Une réduction de {percent}% sera appliquée.",
    previewFixed: "Une réduction de {amount} sera appliquée.",
  },
  share: {
    title: "Partager",
    desc: "Copiez le lien de réservation directe et partagez-le sur WhatsApp ou ouvrez la vue client.",
    linkLabel: "Lien de réservation",
    linkHelp: "Voici le lien que vous partagez avec les clients.",
    viewAsGuest: "Voir en tant que client",
    tip: "Conseil : partagez ce lien dans votre bio, vos messages automatiques et vos campagnes.",
    whatsappMessage: "Bonjour 👋 Voici le lien pour réserver : {link}",
  },
  errors: {
    loadRatePlans: "Impossible de charger les tarifs.",
    saveRatePlans: "Impossible d'enregistrer les tarifs.",
    roomMinVisible: 'La chambre "{name}" doit avoir au moins 1 tarif visible.',
    roomExactlyOneDefault: 'La chambre "{name}" doit avoir exactement 1 tarif par défaut.',
    roomDefaultMustBeVisible: 'Dans "{name}", le tarif par défaut doit être visible.',
    aptMinVisible: "Vous devez conserver au moins 1 tarif visible.",
    aptExactlyOneDefault: "Il doit y avoir exactement 1 tarif par défaut.",
    aptDefaultMustBeVisible: "Le tarif par défaut doit être visible.",
    loadPromotions: "Impossible de charger les promotions.",
    savePromotions: "Impossible d'enregistrer les promotions.",
    saveAddons: "Impossible d'enregistrer les frais supplémentaires.",
    maxExtraRange: "Le nombre maximum de clients supplémentaires doit être compris entre 0 et 50 (ou vide = aucune limite).",
    extraPriceInvalid: "Le prix par client supplémentaire doit être valide (>= 0).",
    percentRange: "Le pourcentage doit être compris entre 0 et 100.",
    baseOccupancyRange: "L'occupation de base doit être comprise entre 1 et {max}.",
    discountValuesInvalid: "Les valeurs de réduction doivent être des nombres valides (>= 0).",
    discountPercentMax: "Les réductions en pourcentage ne peuvent pas dépasser 100.",
    updateFailed: "Impossible de mettre à jour.",
    updateUnitFailed: "Impossible de mettre à jour le statut de l'unité.",
    updateGlobalFailed: "Impossible de mettre à jour le statut global.",
    noLinkCopy: "Aucun lien à copier.",
    copyFailed: "Impossible de copier le lien.",
    noLinkShare: "Aucun lien à partager.",
    noLinkOpen: "Aucun lien à ouvrir.",
    updatePaymentType: "Impossible de mettre à jour le type de paiement.",
    savePayments: "Impossible d'enregistrer les modifications.",
  },
  success: {
    ratePlansSaved: "Tarifs enregistrés avec succès.",
    promotionsSaved: "Promotions enregistrées avec succès.",
    addonsSaved: "Frais supplémentaires enregistrés avec succès.",
    updated: "Mis à jour avec succès.",
    globalUpdated: "Statut global mis à jour.",
    linkCopied: "Lien copié.",
    changesSaved: "Modifications enregistrées.",
  },
};
